// API service functions for organizations
import api from './client';

export interface Organization {
  id: number;
  org_id: string;
  name: string;
  description?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface OrganizationCreate {
  org_id: string;
  name: string;
  description?: string;
}

export interface OrganizationUpdate {
  name?: string;
  description?: string;
  is_active?: boolean;
}

export interface OrganizationWithDetails extends Organization {
  users: any[];
  components: any[];
  stores: any[];
}

export const organizationApi = {
  // Create organization
  create: async (data: OrganizationCreate): Promise<Organization> => {
    const response = await api.post('/v1/organizations/', data);
    return response.data;
  },

  // List organizations
  list: async (skip = 0, limit = 100): Promise<Organization[]> => {
    const response = await api.get(`/v1/organizations/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  // Get organization by org_id
  get: async (org_id: string): Promise<OrganizationWithDetails> => {
    const response = await api.get(`/v1/organizations/${org_id}`);
    return response.data;
  },

  // Update organization
  update: async (org_id: string, data: OrganizationUpdate): Promise<Organization> => {
    const response = await api.put(`/v1/organizations/${org_id}`, data);
    return response.data;
  },

  // Disable organization
  disable: async (org_id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/organizations/${org_id}`);
    return response.data;
  },

  // Update organization component access
  updateComponentAccess: async (orgId: string, componentIds: number[]): Promise<{ message: string }> => {
    const response = await api.post(`/v1/organizations/${orgId}/components`, {
      org_id: orgId,
      component_ids: componentIds
    });
    return response.data;
  },

  // Update organization store access
  updateStoreAccess: async (orgId: string, storeIds: number[]): Promise<{ message: string }> => {
    const response = await api.post(`/v1/organizations/${orgId}/stores`, {
      org_id: orgId,
      store_ids: storeIds
    });
    return response.data;
  },

  // Get organization components
  getComponents: async (orgId: string): Promise<any[]> => {
    const response = await api.get(`/v1/organizations/${orgId}/components`);
    return response.data;
  },

  // Get organization stores
  getStores: async (orgId: string): Promise<any[]> => {
    const response = await api.get(`/v1/organizations/${orgId}/stores`);
    return response.data;
  },

  // Get organization config
  getConfig: async (orgId: string): Promise<any> => {
    const response = await api.get(`/v1/organizations/${orgId}/config`);
    return response.data;
  },

  // Create organization config
  createConfig: async (orgId: string, data: any): Promise<any> => {
    const response = await api.post(`/v1/organizations/${orgId}/config`, data);
    return response.data;
  },

  // Update organization config
  updateConfig: async (orgId: string, data: any): Promise<any> => {
    const response = await api.put(`/v1/organizations/${orgId}/config`, data);
    return response.data;
  }
};
